<template>
  <mdb-modal removeBackdrop size="md" :show="modalShow" @close="handleClose">
    <mdb-modal-header class="text-center" color="indigo">
      <mdb-modal-title tag="h4" bold class="w-100 text-white">{{
        $t("edit")
      }}</mdb-modal-title>
    </mdb-modal-header>
    <mdb-modal-body class="mx-3" color="white">
      <mdb-input :label="$t('chain_name')" type="text" v-model="chainName" />
      <mdb-input
        :label="$t('chain_description')"
        type="textarea"
        v-model="chainDescription"
      />
    </mdb-modal-body>
    <mdb-modal-footer center>
      <mdb-btn @click="saveEditChain" color="indigo"
        >{{ $t("save") }}<mdb-icon icon="paper-plane" class="ml-1"
      /></mdb-btn>
    </mdb-modal-footer>
  </mdb-modal>
</template>

<script>
import {
  mdbBtn,
  mdbModal,
  mdbModalHeader,
  mdbModalBody,
  mdbInput,
  mdbModalFooter,
  mdbModalTitle,
  mdbIcon
} from "mdbvue";
export default {
  name: "EditRetailerChain",
  props: {
    modalShow: Boolean,
    addChainState: Boolean,
    name: String,
    active: Number,
    description: String,
    id: Number,
  },
  components: {
    mdbBtn,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbInput,
    mdbModalFooter,
    mdbModalTitle,
    mdbIcon
  },
  data() {
    return {
      chainpath: "/1.0/front/retailers/chain",
      chainName: this.name,
      chainDescription: this.description
    };
  },
  methods: {
    handleClose() {
      console.log("modal hide");
      this.$emit("modal-cancelled");
    },
    saveEditChain() {
      this.postdata = JSON.stringify({
        name: this.chainName,
        description: this.chainDescription,
        id: this.id,
        active: this.active
      });
      this.$http
        .post(this.chainpath, this.postdata)
        .then(response => {
          if (response.status == 200) {
            this.$notify.success({
              message: this.$t("adding_chain_success"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutshort
            });
          }
          this.$emit("modal-ok");
        })
        .catch(error => {
          this.$notify.error({
            message: this.$t("adding_chain_not_success"),
            position: "top right",
            timeOut: this.$store.state.notifytimeoutshort
          });
          this.$emit("modal-ok");
          console.log(error);
        })
        .finally(() => (this.loading = false));
    },
  }
};
</script>

<style scoped></style>
